import en from './en/index';
import ru from './ru/index';
import uk from './uk/index';
import pt from './pt/index';
import uz from './uz/index';
import az from './az/index';
import es from './es/index';
import ja from './ja/index';
import zh from './zh/index';
import zhHant from './zhHant/index';

export const messages = {
  en,
  ru,
  uk,
  pt,
  uz,
  az,
  es,
  ja,
  zh,
  'zh-hant': zhHant,
};
